import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useWebsiteT } from '../hooks/use-website-t';
import type { StorefrontEditorData } from '../hooks/use-storefront-editor-data';
import { WebsiteRuntimeNotice } from './website-runtime-notice';

export interface StorefrontRouteStatesProps {
  readonly data: Exclude<StorefrontEditorData, { readonly status: 'ready' }>;
}

/** The two states before the storefront screens have anything to show. */
export function StorefrontRouteStates({ data }: StorefrontRouteStatesProps): React.JSX.Element {
  const { t, dir } = useWebsiteT();
  if (data.status === 'error') {
    if (data.runtimeUnavailable) {
      return (
        <div className="mx-auto max-w-md px-4 py-16">
          <WebsiteRuntimeNotice storeId={data.storeId} />
        </div>
      );
    }
    return (
      <div
        dir={dir}
        role="alert"
        data-testid="storefront-route-error"
        className="mx-auto flex max-w-md flex-col items-center gap-3 px-4 py-16 text-center"
      >
        <p className="text-foreground text-sm">{t('admin.websiteTemplates.frame.loadError')}</p>
        <Button type="button" variant="outline" onClick={data.retry}>
          {t('admin.websiteTemplates.common.retry')}
        </Button>
      </div>
    );
  }
  return (
    <div
      dir={dir}
      role="status"
      aria-label={t('admin.websiteTemplates.frame.loading')}
      data-testid="storefront-route-loading"
      className="mx-auto max-w-screen-xl space-y-4 px-4 py-8 sm:px-6"
    >
      <Skeleton className="h-10 w-64" />
      <Skeleton className="h-96 w-full" />
    </div>
  );
}
